export default __webpack_public_path__ + "static/media/doctor-talking.0abdbb67.svg";